import { useProductDetailContext } from '@containers/ProductDetailContainer/ProductDetailContext';
import { useApolloClientHeaders } from '@hooks/useApolloClientHeaders';

export const useOtherTab = () => {
  const isFranceShop = useApolloClientHeaders().shopId === 'notino.fr';
  const { product, currentVariant } = useProductDetailContext();

  const { specialStorage, importantNotice, manufacturerImporter } =
    currentVariant.documentation || {};
  const { producer, contactAddress, postalAddress } = product.brand || {};

  const shouldRenderOthersTab = Boolean(
    specialStorage ||
      importantNotice ||
      producer?.postalAddress ||
      manufacturerImporter ||
      contactAddress ||
      postalAddress ||
      isFranceShop
  );

  return {
    shouldRenderOthersTab,
    specialStorage,
    producerPostalAddress: producer?.postalAddress,
    manufacturerImporter,
    contactAddress,
    postalAddress,
    isFranceShop,
    importantNotice,
  };
};
